<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" md="6">
                        <MultiplaEscolha
                            ref="linhasSelect"
                            lazy
                            get-url="getLinhaslazy"
                            v-bind:selected-items.sync="linhasSelecionadas"
                            :all-matching-selected.sync="linhasAllMatching"
                            text="nome_linha"
                            value="id_linha"
                            :label="$t('nav.registration.lines')"
                            :max-items="2"
                            can-toggle-all
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-datetime-picker :label="$t('diagComparacaoEtas.startDate')" v-model="dti"
                            :time-picker-props="timeProps" :date-picker-props="dtiProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('button.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-datetime-picker :label="$t('diagComparacaoEtas.endDate')" v-model="dtf"
                            :time-picker-props="timeProps" :date-picker-props="dtfProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('button.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                </v-row>
                <v-row align="center">
                    <v-col cols="12" md="4">
                        <div class="text-caption grey--text text--darken-1">
                            {{ $t('routePlanning.fields.passengerSearchTime') }}
                        </div>
                        <v-radio-group v-model="stopServiceMode" row hide-details="auto" class="mt-0 pt-0">
                            <v-radio :label="$t('routePlanning.fields.stopTimeModeVariable')" value="variavel" />
                            <v-radio :label="$t('routePlanning.fields.stopTimeModeFixed')" value="fixo" />
                        </v-radio-group>
                    </v-col>
                    <v-col v-if="stopServiceMode === 'fixo'" cols="12" md="3">
                        <v-text-field v-model="stopServiceFixedSec" type="number" min="0" step="1" suffix="s"
                            :label="$t('routePlanning.fields.fixedStopTime')" :rules="stopServiceTimeRules" />
                    </v-col>
                    <v-col v-else cols="12" md="3">
                        <v-text-field v-model="stopServicePerPassengerSec" type="number" min="0" step="1" suffix="s"
                            :label="$t('routePlanning.fields.perPassengerTime')" :rules="stopServiceTimeRules" />
                    </v-col>
                </v-row>
                <v-row align="center">
                    <v-col cols="12" md="4">
                        <div class="text-caption grey--text text--darken-1">
                            {{ $t('diagComparacaoEtas.alightTime') }}
                        </div>
                        <v-radio-group v-model="alightServiceMode" row hide-details="auto" class="mt-0 pt-0">
                            <v-radio :label="$t('routePlanning.fields.stopTimeModeVariable')" value="variavel" />
                            <v-radio :label="$t('routePlanning.fields.stopTimeModeFixed')" value="fixo" />
                        </v-radio-group>
                    </v-col>
                    <v-col v-if="alightServiceMode === 'fixo'" cols="12" md="3">
                        <v-text-field v-model="alightServiceFixedSec" type="number" min="0" step="1" suffix="s"
                            :label="$t('routePlanning.fields.fixedStopTime')" :rules="stopServiceTimeRules" />
                    </v-col>
                    <v-col v-else cols="12" md="3">
                        <v-text-field v-model="alightServicePerPassengerSec" type="number" min="0" step="1" suffix="s"
                            :label="$t('routePlanning.fields.perPassengerTime')" :rules="stopServiceTimeRules" />
                    </v-col>

                    <v-col cols="12" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    :loading="processando" :disabled="processando"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
        <v-container class="toolbar__container" style="margin-top: 2%; max-width: 100%; margin-bottom: 2%;">
            <v-row>
                    <v-col cols="12" md="4">
                        <v-switch v-model="incluiDeslocamento" dense hide-details class="mt-1"
                                        :label="$t('diagComparacaoEtas.etaComposition.displacement')"
                                        :hint="$t('diagComparacaoEtas.etaComposition.displacementHint')"
                                        persistent-hint />
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-switch v-model="contabilizaEmbarqueVolta" dense hide-details class="mt-1"
                                        :label="$t('diagComparacaoEtas.etaComposition.boardingReturn')"
                                        :hint="$t('diagComparacaoEtas.etaComposition.boardingReturnHint')"
                                        persistent-hint />
                    </v-col>
                    <v-col cols="12" md="4">
                                    <v-switch v-model="contabilizaDesembarqueIda" dense hide-details class="mt-1"
                                        :label="$t('diagComparacaoEtas.etaComposition.alightingOutbound')"
                                        :hint="$t('diagComparacaoEtas.etaComposition.alightingOutboundHint')"
                                        persistent-hint />
                    </v-col>
                </v-row>
        </v-container>

        <v-alert v-if="aviso" type="warning" dense text class="mb-2">{{ aviso }}</v-alert>

        <LoadingComponent
            :loading="processando"
            :message="mensagemLoading"
            :progress-percent="percentualEtapa"
            style="z-index: 1000;"
        />

        <v-card class="elevation-7" style="border-radius: 10px; margin-top: 10px; margin-bottom: 10px;">
            <MerusDataTable :headers="headersDefault" :items="itensTabela" :search="search"
                item-key="id_comparacao" flat show-columns-button
                @update:headers="valoresOcultosDefault = valoresOcultos($event)">
                <template v-slot:toolbar>
                    <CadastroToolbar :title="$t('diagComparacaoEtas.title')" :token="token"
                        :items="itensTabela"
                        csv-title="comparacao_etas" :csv-headers="headersExportacaoDefault"
                        :pdf-title="$t('diagComparacaoEtas.title')" :pdf-headers="headersExportacaoDefault"
                        :pdf-subtitle="pdfSubtitulo" pdf-filename="comparacao_etas"
                        @search="search = $event">
                    </CadastroToolbar>
                </template>

                <template v-slot:item.descricao_quadro="{ item }">
                    <span>{{ item.descricao_quadro }}</span>
                    <v-tooltip bottom v-if="item.n_quadros > 1">
                        <template v-slot:activator="{ on, attrs }">
                            <v-chip x-small class="ml-1" v-bind="attrs" v-on="on">{{ item.n_quadros }}</v-chip>
                        </template>
                        <span>{{ textoQuadrosAgrupados(item) }}</span>
                    </v-tooltip>
                </template>

                <template v-slot:item.tempo_previsto_min="{ item }">
                    {{ formatMinutos(item.tempo_previsto_min) }}
                </template>

                <template v-slot:item.media_realizada_min="{ item }">
                    <v-tooltip bottom v-if="item.media_realizada_min == null">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">&mdash;</span>
                        </template>
                        <span>{{ $t('diagComparacaoEtas.messages.noCompletedTrips') }}</span>
                    </v-tooltip>
                    <span v-else>
                        {{ formatMinutos(item.media_realizada_min) }}
                    </span>
                </template>

                <template v-slot:item.eta_total_min="{ item }">
                    <v-progress-circular v-if="item.eta_status === 'PENDENTE'" indeterminate size="16" width="2"
                        color="primary" />
                    <v-tooltip bottom v-else-if="item.eta_status === 'OK'">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">{{ formatMinutos(item.eta_total_min) }}</span>
                        </template>
                        <span>{{ etaComposicao(item) }}</span>
                    </v-tooltip>
                    <v-chip v-else x-small>{{ etaStatusLabel(item.eta_status) }}</v-chip>
                </template>

                <template v-slot:item.eta_percurso_min="{ item }">
                    {{ formatMinutos(item.eta_percurso_min) }}
                </template>
                <template v-slot:item.eta_deslocamento_min="{ item }">
                    {{ formatMinutos(item.eta_deslocamento_min) }}
                </template>
                <template v-slot:item.eta_servico_paradas_min="{ item }">
                    {{ formatMinutos(item.eta_servico_paradas_min) }}
                </template>
                <template v-slot:item.eta_servico_terminal_min="{ item }">
                    {{ formatMinutos(item.eta_servico_terminal_min) }}
                </template>
                <template v-slot:item.min_realizada_min="{ item }">
                    {{ formatMinutos(item.min_realizada_min) }}
                </template>
                <template v-slot:item.max_realizada_min="{ item }">
                    {{ formatMinutos(item.max_realizada_min) }}
                </template>

                <template v-slot:item.delta_previsto_realizado="{ item }">
                    <span :class="classeDelta(item.delta_previsto_realizado)">
                        {{ formatDelta(item.delta_previsto_realizado) }}
                    </span>
                </template>
                <template v-slot:item.delta_eta_previsto="{ item }">
                    <span :class="classeDelta(item.delta_eta_previsto)">
                        {{ formatDelta(item.delta_eta_previsto) }}
                    </span>
                </template>
                <template v-slot:item.delta_eta_realizado="{ item }">
                    <span :class="classeDelta(item.delta_eta_realizado)">
                        {{ formatDelta(item.delta_eta_realizado) }}
                    </span>
                </template>
            </MerusDataTable>
        </v-card>

        <v-card class="elevation-7" style="border-radius: 10px; margin-bottom: 10px;">
            <MerusDataTable :headers="headersFaixas" :items="itensFaixas" :search="searchFaixa"
                item-key="id_faixa" flat show-columns-button
                @update:headers="valoresOcultosFaixas = valoresOcultos($event)">
                <template v-slot:toolbar>
                    <CadastroToolbar :title="$t('diagComparacaoEtas.bandTableTitle')" :token="token"
                        :items="itensFaixas" csv-title="comparacao_etas_faixas" :csv-headers="headersExportacaoFaixas"
                        :pdf-title="$t('diagComparacaoEtas.bandTableTitle')" :pdf-headers="headersExportacaoFaixas"
                        :pdf-subtitle="pdfSubtituloFaixas" pdf-filename="comparacao_etas_faixas"
                        @search="searchFaixa = $event">
                        <template v-slot:extension>
                            <v-select v-model="intervaloFaixaMin" :items="opcoesIntervaloFaixa" dense hide-details
                                :label="$t('diagComparacaoEtas.bandInterval')"  style="max-width: 150px; padding-top: 8px;" />
                        </template>
                    </CadastroToolbar>
                </template>

                <template v-slot:item.tempo_previsto_min="{ item }">
                    {{ formatMinutos(item.tempo_previsto_min) }}
                </template>

                <template v-slot:item.media_realizada_min="{ item }">
                    <v-tooltip bottom v-if="item.media_realizada_min == null">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">&mdash;</span>
                        </template>
                        <span>{{ $t('diagComparacaoEtas.messages.noCompletedTrips') }}</span>
                    </v-tooltip>
                    <span v-else>
                        {{ formatMinutos(item.media_realizada_min) }}
                    </span>
                </template>

                <template v-slot:item.eta_total_min="{ item }">
                    <v-tooltip bottom v-if="item.eta_total_min != null">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">{{ formatMinutos(item.eta_total_min) }}</span>
                        </template>
                        <span>{{ textoCoberturaEta(item) }}</span>
                    </v-tooltip>
                    <span v-else>&mdash;</span>
                </template>

                <template v-slot:item.delta_previsto_realizado="{ item }">
                    <span :class="classeDelta(item.delta_previsto_realizado)">
                        {{ formatDelta(item.delta_previsto_realizado) }}
                    </span>
                </template>
                <template v-slot:item.delta_eta_previsto="{ item }">
                    <span :class="classeDelta(item.delta_eta_previsto)">
                        {{ formatDelta(item.delta_eta_previsto) }}
                    </span>
                </template>
                <template v-slot:item.delta_eta_realizado="{ item }">
                    <span :class="classeDelta(item.delta_eta_realizado)">
                        {{ formatDelta(item.delta_eta_realizado) }}
                    </span>
                </template>
            </MerusDataTable>
        </v-card>
    </v-container>
</template>
<script>

import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import MerusDataTable from "../components/Tables/MerusDataTable.vue";
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import LoadingComponent from './LoadingComponent.vue';
import apiController from '@/utils/apiController';
import DateUtils from '../utils/dateutils.js';

/** Mesmo teto de `MAX_STOP_SERVICE_SECONDS` em api/routers/verso/getsolve.js. */
const MAX_SERVICE_SEC = 3600;
/** `cte_max_recursion_depth` padrão do MySQL limita a CTE de datas do agregado. */
const MAX_DIAS_PERIODO = 366;
/** Abaixo disto a média realizada é estatisticamente frágil e recebe alerta na célula. */
const AMOSTRA_MINIMA_VIAGENS = 3;
/** Mesmo mapa de isSentidoVolta() em src/utils/allocationFenceCreation.js. */
const SENTIDOS_VOLTA = new Set([2, 5, 6]);
/** Contrato de `etas` devolvido pelo worker; abaixo disto o ETA vinha sem as parcelas. */
const VERSAO_ETAS_ESPERADA = 2;
/** Larguras de faixa oferecidas no resumo por faixa de horário, em minutos. */
const INTERVALOS_FAIXA_MIN = [30, 60, 120];

/** Intervalo de consulta ao scheduler enquanto o relatório é gerado. */
const INTERVALO_POLL_MS = 2000;
/** Retoma o acompanhamento se o usuário sair da tela e voltar. */
const STORAGE_KEY = 'diagComparacaoEtasProcesso';

/** Etapas gravadas pelo worker em results/<id>.progress.json, na ordem de execução. */
const ETAPAS = ['horarios', 'cercas', 'embarques', 'etas'];

const ETA_STATUS_KEYS = {
    POUCAS_CERCAS: 'insufficientFences',
    RATE_LIMIT: 'rateLimit',
    NO_STOPS: 'insufficientFences',
    NO_ROUTE: 'noRoute',
    NO_SOLUTION: 'noRoute',
    NO_GEOMETRY: 'noRoute',
};

export default {
    components: {
        MultiplaEscolha,
        MerusDataTable,
        CadastroToolbar,
        LoadingComponent,
    },
    data: () => ({
        user: null,
        token: null,
        config: null,
        formValidado: false,
        linhasSelecionadas: [],
        linhasAllMatching: false,
        dti: null,
        dtf: null,
        timeProps: {
            useSeconds: true,
        },
        stopServiceMode: 'variavel',
        stopServiceFixedSec: null,
        stopServicePerPassengerSec: null,
        alightServiceMode: 'variavel',
        alightServiceFixedSec: null,
        alightServicePerPassengerSec: null,
        // Filtros de composição do ETA: desligados, o ETA é a viagem de passageiro pura,
        // que é o que o quadro de horários mede.
        incluiDeslocamento: false,
        contabilizaEmbarqueVolta: false,
        contabilizaDesembarqueIda: false,
        horarios: [],
        // Linhas de fato enviadas na consulta ([{ id_linha, nome }]). O resultado sozinho nao
        // serve de fonte para o cabecalho: uma linha sem viagem no periodo nao volta em
        // `horarios` e sumia do PDF, que dizia 38 linhas quando o usuario tinha pedido 40.
        linhasConsultadas: [],
        etaPorLinhaSentido: {},
        intervaloFaixaMin: 60,
        search: "",
        searchFaixa: "",
        // null enquanto o usuário não mexe no seletor de colunas: aí valem os `show` dos headers.
        valoresOcultosDefault: null,
        valoresOcultosFaixas: null,
        aviso: "",
        buscando: false,
        // Acompanhamento do processo no scheduler.
        idProcesso: null,
        statusProcesso: null,
        etapaAtual: null,
        etapaTotal: 0,
        etapaConcluidos: 0,
        segundosDecorridos: 0,
        pollTimer: null,
        elapsedTimer: null,
    }),
    computed: {
        processando() {
            return this.buscando || Boolean(this.idProcesso);
        },
        mensagemLoading() {
            if (this.etapaAtual) {
                return this.$t(`diagComparacaoEtas.stages.${this.etapaAtual}`);
            }
            return this.$t('diagComparacaoEtas.loading');
        },
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')],
            };
        },
        stopServiceTimeRules() {
            return [
                (v) => (v !== '' && v != null && String(v).trim() !== '') || this.$t('routePlanning.validation.stopServiceTimeRequired'),
                (v) => (Number.isFinite(Number(v)) && Number(v) >= 0 && Number(v) <= MAX_SERVICE_SEC) || this.$t('routePlanning.validation.stopServiceTimeMin'),
            ];
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.today,
            };
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                    min = this.dti.toISOString().substring(0, 10);
                }
            }
            return {
                min: min,
            };
        },
        /** Etapas exibidas no acompanhamento, na ordem em que o worker as grava. */
        etapas() {
            const indiceAtual = ETAPAS.indexOf(this.etapaAtual);
            return ETAPAS
                .map((chave) => {
                    const indice = ETAPAS.indexOf(chave);
                    let estado = 'pendente';
                    if (indiceAtual >= 0 && indice < indiceAtual) estado = 'concluida';
                    else if (indice === indiceAtual) estado = 'atual';
                    return {
                        chave,
                        estado,
                        label: this.$t(`diagComparacaoEtas.stages.${chave}`),
                    };
                });
        },
        percentualEtapa() {
            if (this.etapaAtual !== 'etas' || !this.etapaTotal) return null;
            return Math.round((this.etapaConcluidos * 100) / this.etapaTotal);
        },
        tempoDecorrido() {
            const total = this.segundosDecorridos;
            const m = String(Math.floor(total / 60)).padStart(2, '0');
            const s = String(total % 60).padStart(2, '0');
            return `${m}:${s}`;
        },
        headersDefault() {
            return [
                this.criaHeader('lineCode', 'cod_linha'),
                this.criaHeader('lineName', 'nome_linha'),
                this.criaHeader('direction', 'descricao_sentido'),
                this.criaHeader('timetable', 'descricao_quadro'),
                this.criaHeader('departure', 'horario_saida'),
                this.criaHeader('arrival', 'horario_chegada'),
                this.criaHeader('shift', 'descricao_turno', false),
                this.criaHeader('scheduled', 'tempo_previsto_min', true, this.formataMinutosExport),
                this.criaHeader('actualAverage', 'media_realizada_min', true, this.formataMinutosExport),
                this.criaHeader('trips', 'n_viagens_realizadas'),
                this.criaHeader('eta', 'eta_total_min', true, this.formataEtaExport),
                this.criaHeader('deltaScheduledActual', 'delta_previsto_realizado', true, this.formataDeltaExport),
                this.criaHeader('deltaEtaScheduled', 'delta_eta_previsto', true, this.formataDeltaExport),
                this.criaHeader('deltaEtaActual', 'delta_eta_realizado', true, this.formataDeltaExport),
                this.criaHeader('etaMainTravel', 'eta_percurso_min', false, this.formataMinutosExport),
                this.criaHeader('etaGarageTravel', 'eta_deslocamento_min', false, this.formataMinutosExport),
                this.criaHeader('etaStopsService', 'eta_servico_paradas_min', false, this.formataMinutosExport),
                this.criaHeader('etaTerminalService', 'eta_servico_terminal_min', false, this.formataMinutosExport),
                this.criaHeader('etaStopsPassengers', 'passageiros_paradas_total', false),
                this.criaHeader('etaTerminalPassengers', 'passageiros_terminal', false),
                this.criaHeader('minActual', 'min_realizada_min', false, this.formataMinutosExport),
                this.criaHeader('maxActual', 'max_realizada_min', false, this.formataMinutosExport),
            ];
        },
        /**
         * Resumo dos parâmetros da consulta e dos filtros no rodapé do cabeçalho do PDF: sem
         * isso o relatório impresso não diz de que período, de que tempos nem de que
         * composição do ETA ele saiu.
         */
        pdfSubtitulo() {
            return this.montaSubtitulo([]).join('\n');
        },
        pdfSubtituloFaixas() {
            const intervalo = this.$t(`diagComparacaoEtas.bandIntervals.min${this.intervaloFaixaMin}`);
            return this.montaSubtitulo([
                `${this.$t('diagComparacaoEtas.bandInterval')}: ${intervalo}`,
            ]).join('\n');
        },
        /**
         * Linhas que a consulta cobriu, na seleção resolvida na hora da busca — inclusive as que
         * não voltaram nenhuma viagem. Quando a seleção não existe mais (resultado retomado do
         * sessionStorage depois de recarregar a tela), cai para o que o resultado mostra.
         */
        linhasDoRelatorio() {
            if (this.linhasConsultadas.length) return this.linhasConsultadas;
            const porLinha = new Map();
            (this.horarios || []).forEach((r) => {
                if (!r || r.id_linha == null || porLinha.has(r.id_linha)) return;
                porLinha.set(r.id_linha, { id_linha: r.id_linha, nome: this.rotuloLinha(r) });
            });
            return Array.from(porLinha.values());
        },
        nomesDasLinhas() {
            return this.linhasDoRelatorio
                .map((l) => l.nome)
                .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
        },
        /**
         * Linhas pedidas que não geraram nenhuma viagem — sem quadro válido para os dias da
         * semana do período, ou com cadastro que não passa pelos JOINs de turno/sentido. Antes
         * elas sumiam em silêncio do relatório e da contagem do cabeçalho.
         */
        nomesDasLinhasSemViagens() {
            if (!this.linhasConsultadas.length || !(this.horarios || []).length) return [];
            const comViagens = new Set(
                (this.horarios || [])
                    .filter((r) => r && r.id_linha != null)
                    .map((r) => String(r.id_linha))
            );
            return this.linhasConsultadas
                .filter((l) => !comViagens.has(String(l.id_linha)))
                .map((l) => l.nome)
                .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
        },
        textoComposicaoFiltros() {
            const ligados = [];
            if (this.incluiDeslocamento) ligados.push(this.$t('diagComparacaoEtas.etaComposition.displacement'));
            if (this.contabilizaEmbarqueVolta) ligados.push(this.$t('diagComparacaoEtas.etaComposition.boardingReturn'));
            if (this.contabilizaDesembarqueIda) ligados.push(this.$t('diagComparacaoEtas.etaComposition.alightingOutbound'));
            return ligados.length ? ligados.join(', ') : this.$t('diagComparacaoEtas.etaComposition.none');
        },
        headersExportacaoDefault() {
            return this.aplicaColunasOcultas(this.headersDefault, this.valoresOcultosDefault);
        },
        headersExportacaoFaixas() {
            return this.aplicaColunasOcultas(this.headersFaixas, this.valoresOcultosFaixas);
        },
        /** Tempo de embarque: paradas da ida e terminal da volta. */
        cfgEmbarque() {
            return this.normalizaCfgServico(
                this.stopServiceMode, this.stopServiceFixedSec, this.stopServicePerPassengerSec
            );
        },
        /** Tempo de desembarque: paradas da volta e terminal da ida. */
        cfgDesembarque() {
            return this.normalizaCfgServico(
                this.alightServiceMode, this.alightServiceFixedSec, this.alightServicePerPassengerSec
            );
        },
        opcoesIntervaloFaixa() {
            return INTERVALOS_FAIXA_MIN.map((minutos) => ({
                value: minutos,
                text: this.$t(`diagComparacaoEtas.bandIntervals.min${minutos}`),
            }));
        },
        headersFaixas() {
            return [
                this.criaHeader('direction', 'descricao_sentido'),
                this.criaHeader('timeBand', 'faixa_horario'),
                this.criaHeader('scheduledTrips', 'n_horarios'),
                this.criaHeader('scheduled', 'tempo_previsto_min', true, this.formataMinutosExport),
                this.criaHeader('actualAverage', 'media_realizada_min', true, this.formataMinutosExport),
                this.criaHeader('trips', 'n_viagens_realizadas'),
                this.criaHeader('etaAverage', 'eta_total_min', true, this.formataMinutosExport),
                this.criaHeader('deltaScheduledActual', 'delta_previsto_realizado', true, this.formataDeltaExport),
                this.criaHeader('deltaEtaScheduled', 'delta_eta_previsto', true, this.formataDeltaExport),
                this.criaHeader('deltaEtaActual', 'delta_eta_realizado', true, this.formataDeltaExport),
            ];
        },
        /**
         * Agrupa os horários do quadro em faixas de largura `intervaloFaixaMin`, por sentido, consolidando
         * todas as linhas consultadas: é uma visão do período do dia, não da linha.
         * A faixa tem três médias: previsto (todos os horários), realizado (ponderado por
         * `n_viagens_realizadas`, já que cada linha da tabela detalhada é a média de N viagens) e ETA
         * (um por horário com rota calculada). Os três deltas são diferenças dessas médias, nunca
         * médias de diferenças: é o que mantém as colunas coerentes entre si, porque as médias têm
         * bases diferentes (um horário sem viagem realizada ainda tem previsto e ETA) e a média das
         * diferenças de cada uma não fecharia com as demais. Assim Δ ETA − Realizado menos
         * Δ Previsto − Realizado sempre resulta em Δ ETA − Previsto, a menos do arredondamento.
         * O ETA médio é a média dos ETAs dos horários com rota calculada. Como o ETA é constante por
         * linha/sentido, cada linha pesa pelo número de partidas que tem na faixa, e `n_horarios_com_eta`
         * diz sobre quantos horários a média foi tirada — as linhas sem rota ficam de fora.
         */
        itensFaixas() {
            const intervalo = Number(this.intervaloFaixaMin) || 60;
            const grupos = new Map();
            (this.itensTabela || []).forEach((item) => {
                const minutos = this.minutosDoHorario(item.horario_saida);
                if (minutos == null) return;
                const inicio = Math.floor(minutos / intervalo) * intervalo;
                const chave = `${item.id_sentido}:${inicio}`;
                let grupo = grupos.get(chave);
                if (!grupo) {
                    grupo = {
                        id_faixa: `${item.id_sentido}-${inicio}`,
                        descricao_sentido: item.descricao_sentido,
                        id_sentido: item.id_sentido,
                        inicio_faixa_min: inicio,
                        faixa_horario: `${this.formatMinutos(inicio)} - ${this.formatMinutos(inicio + intervalo)}`,
                        n_horarios: 0,
                        n_viagens_realizadas: 0,
                        somaPrevisto: 0,
                        pesoPrevisto: 0,
                        somaRealizado: 0,
                        pesoRealizado: 0,
                        somaEta: 0,
                        pesoEta: 0,
                    };
                    grupos.set(chave, grupo);
                }
                const viagens = Number(item.n_viagens_realizadas) || 0;
                grupo.n_horarios += 1;
                grupo.n_viagens_realizadas += viagens;
                if (item.tempo_previsto_min != null) {
                    grupo.somaPrevisto += Number(item.tempo_previsto_min);
                    grupo.pesoPrevisto += 1;
                }
                if (item.media_realizada_min != null && viagens > 0) {
                    grupo.somaRealizado += Number(item.media_realizada_min) * viagens;
                    grupo.pesoRealizado += viagens;
                }
                if (item.eta_total_min != null) {
                    grupo.somaEta += Number(item.eta_total_min);
                    grupo.pesoEta += 1;
                }
            });
            return Array.from(grupos.values())
                .map((grupo) => {
                    const previsto = this.media(grupo.somaPrevisto, grupo.pesoPrevisto);
                    const realizado = this.media(grupo.somaRealizado, grupo.pesoRealizado);
                    const eta = this.media(grupo.somaEta, grupo.pesoEta);
                    return {
                        id_faixa: grupo.id_faixa,
                        descricao_sentido: grupo.descricao_sentido,
                        id_sentido: grupo.id_sentido,
                        inicio_faixa_min: grupo.inicio_faixa_min,
                        faixa_horario: grupo.faixa_horario,
                        n_horarios: grupo.n_horarios,
                        n_viagens_realizadas: grupo.n_viagens_realizadas,
                        n_horarios_com_eta: grupo.pesoEta,
                        tempo_previsto_min: previsto,
                        eta_total_min: eta,
                        media_realizada_min: realizado,
                        delta_previsto_realizado: this.delta(previsto, realizado),
                        delta_eta_previsto: this.delta(eta, previsto),
                        delta_eta_realizado: this.delta(eta, realizado),
                    };
                })
                .sort((a, b) => a.id_sentido - b.id_sentido || a.inicio_faixa_min - b.inicio_faixa_min);
        },
        /**
         * O worker devolve o ETA em parcelas — perna da garagem, percurso de passageiros e a
         * contagem de passageiros de cada parada e do terminal — e a soma acontece aqui. É o que
         * deixa os filtros de composição e os tempos de embarque/desembarque instantâneos: mudar
         * qualquer um deles recompõe a tabela sem refazer o relatório.
         */
        itensTabela() {
            return (this.horarios || []).map((r) => {
                const eta = this.etaPorLinhaSentido[`${r.id_linha}:${r.id_sentido}`] || null;
                const previsto = r.tempo_previsto_min != null ? Number(r.tempo_previsto_min) : null;
                const realizado = r.media_realizada_min != null ? Number(r.media_realizada_min) : null;
                const ok = Boolean(eta && eta.ok);
                const parcelas = ok ? this.parcelasDoEta(eta, SENTIDOS_VOLTA.has(Number(r.id_sentido))) : null;
                const etaTotal = parcelas ? parcelas.total_min : null;
                return {
                    ...r,
                    id_comparacao: `${r.id_linha}-${r.id_sentido}-${r.id_viagem}`,
                    tempo_previsto_min: previsto,
                    media_realizada_min: realizado,
                    eta_total_min: etaTotal,
                    eta_percurso_min: parcelas ? parcelas.percurso_min : null,
                    eta_deslocamento_min: parcelas ? parcelas.deslocamento_min : null,
                    eta_servico_paradas_min: parcelas ? parcelas.servico_paradas_min : null,
                    eta_servico_terminal_min: parcelas ? parcelas.servico_terminal_min : null,
                    passageiros_paradas_total: parcelas ? parcelas.passageiros_paradas : null,
                    passageiros_terminal: parcelas ? parcelas.passageiros_terminal : null,
                    eta_status: ok ? 'OK' : ((eta && eta.code) || 'NO_SOLUTION'),
                    delta_previsto_realizado: this.delta(previsto, realizado),
                    delta_eta_previsto: this.delta(etaTotal, previsto),
                    delta_eta_realizado: this.delta(etaTotal, realizado),
                };
            });
        },
    },
    watch: {
        '$i18n.locale'() {
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.getConfig();
        this.retomaProcessoPendente();
    },
    beforeDestroy() {
        this.paraTimers();
    },
    methods: {
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    // Relatório retrospectivo: viagens de hoje ainda não terminaram e não entram
                    // no realizado, então o padrão é o dia de operação anterior.
                    [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(
                        this.config.hora_inicial_dia_operacao
                    );
                    const fixo = Number(this.config.tempo_busca_fixo_parada_segundos);
                    this.stopServiceFixedSec = Number.isFinite(fixo) ? fixo : 180;
                    const porPassageiro = Number(this.config.tempo_busca_por_passageiro_segundos);
                    this.stopServicePerPassengerSec = Number.isFinite(porPassageiro) ? porPassageiro : 10;
                    const desembarqueFixo = Number(this.config.tempo_desembarque_fixo_parada_segundos);
                    this.alightServiceFixedSec = Number.isFinite(desembarqueFixo) ? desembarqueFixo : 180;
                    const desembarquePorPassageiro = Number(this.config.tempo_desembarque_por_passageiro_segundos);
                    this.alightServicePerPassengerSec = Number.isFinite(desembarquePorPassageiro)
                        ? desembarquePorPassageiro
                        : 10;
                },
            });
        },

        /**
         * `exportFormat` faz o PDF sair com a mesma formatação da tela (HH:MM e sinal do
         * delta); sem ele o relatório imprimiria os minutos decimais crus do item.
         */
        criaHeader(key, value, show = true, exportFormat = null) {
            return {
                text: this.$t(`diagComparacaoEtas.headers.${key}`),
                value,
                sortable: true,
                filtrable: true,
                show,
                translation_key: `diagComparacaoEtas.headers.${key}`,
                ...(exportFormat ? { exportFormat } : {}),
            };
        },
        /**
         * Guarda só os `value` escondidos no seletor de colunas: os headers da exportação continuam
         * saindo do computed, para os textos acompanharem a troca de idioma.
         */
        valoresOcultos(headers) {
            return (headers || []).filter((h) => h.show === false).map((h) => h.value);
        },
        aplicaColunasOcultas(headers, ocultos) {
            if (!ocultos) return headers;
            return headers.map((h) => ({ ...h, show: !ocultos.includes(h.value) }));
        },
        /** `horario_saida` chega do SQL como 'HH:MM'; devolve os minutos desde a meia-noite. */
        minutosDoHorario(horario) {
            if (!horario) return null;
            const partes = String(horario).split(':');
            if (partes.length < 2) return null;
            const horas = Number(partes[0]);
            const minutos = Number(partes[1]);
            if (!Number.isFinite(horas) || !Number.isFinite(minutos)) return null;
            return (horas * 60) + minutos;
        },
        /**
         * Cabeçalho do PDF em linhas rotuladas, uma por assunto, em vez de um parágrafo só:
         * período, tempos, composição do ETA, filtros e, por último, as linhas consultadas —
         * que é a parte que pode ficar longa.
         */
        montaSubtitulo(extras) {
            const t = (k) => this.$t(`diagComparacaoEtas.${k}`);
            const linhas = [
                `${t('startDate')}: ${this.textoDataFiltro(this.dti)}`
                    + `   ${t('endDate')}: ${this.textoDataFiltro(this.dtf)}`,
                `${this.$t('routePlanning.fields.passengerSearchTime')}: ${this.textoCfgServico(this.cfgEmbarque)}`
                    + `   ${t('alightTime')}: ${this.textoCfgServico(this.cfgDesembarque)}`,
                `${t('etaComposition.title')}: ${this.textoComposicaoFiltros}`,
            ];
            (extras || []).forEach((extra) => linhas.push(extra));
            const nomes = this.nomesDasLinhas;
            const rotuloLinhas = `${this.$t('nav.registration.lines')} (${nomes.length})`;
            linhas.push(`${rotuloLinhas}: ${nomes.length ? nomes.join(', ') : '—'}`);
            const semViagens = this.nomesDasLinhasSemViagens;
            if (semViagens.length) {
                linhas.push(this.textoLinhasSemViagens(semViagens));
            }
            return linhas;
        },
        /** Rótulo de uma linha, com o mesmo fallback do select: nome, código e por fim o id. */
        rotuloLinha(origem) {
            if (!origem) return '';
            const nome = String(origem.nome_linha || origem.cod_linha || origem.id_linha || '').trim();
            return nome || String(origem.id_linha != null ? origem.id_linha : '');
        },
        textoLinhasSemViagens(nomes) {
            return this.$t('diagComparacaoEtas.messages.linesWithoutTrips', {
                count: nomes.length,
                names: nomes.join(', '),
            });
        },
        textoCfgServico(cfg) {
            return cfg.mode === 'fixo'
                ? `${this.$t('routePlanning.fields.stopTimeModeFixed')}: ${cfg.fixedSec} ${this.$t('routePlanning.fields.stopTimePerStopSuffix')}`
                : `${this.$t('routePlanning.fields.stopTimeModeVariable')}: ${cfg.perPassengerSec} ${this.$t('routePlanning.fields.stopTimePerPassengerSuffix')}`;
        },
        textoDataFiltro(valor) {
            if (!valor) return '—';
            if (typeof valor === 'string') return valor;
            return valor.toLocaleString ? valor.toLocaleString() : String(valor);
        },
        normalizaCfgServico(modo, fixoSec, porPassageiroSec) {
            return {
                mode: modo === 'fixo' ? 'fixo' : 'variavel',
                fixedSec: Math.max(0, Number(fixoSec) || 0),
                perPassengerSec: Math.max(0, Number(porPassageiroSec) || 0),
            };
        },
        /** Segundos de uma parada. Espelho de jobServiceSeconds() em Roteirizacao.vue. */
        servicoDeUmaParada(passageiros, cfg) {
            if (cfg.mode === 'fixo') return cfg.fixedSec;
            return cfg.perPassengerSec * Math.max(1, Number(passageiros) || 1);
        },
        /**
         * Parcelas do ETA em minutos, já aplicando os filtros de composição.
         * Na ida as paradas são de embarque e o terminal (o CD) é de desembarque; na volta é o
         * contrário. O terminal só entra quando o filtro do sentido correspondente está ligado.
         */
        parcelasDoEta(eta, volta) {
            const cfgParadas = volta ? this.cfgDesembarque : this.cfgEmbarque;
            const cfgTerminal = volta ? this.cfgEmbarque : this.cfgDesembarque;
            const paradas = Array.isArray(eta.passageiros_paradas) ? eta.passageiros_paradas : [];
            const nParadas = Number(eta.n_paradas) || paradas.length;
            const servicoParadas = cfgParadas.mode === 'fixo'
                ? cfgParadas.fixedSec * nParadas
                : paradas.reduce((soma, p) => soma + this.servicoDeUmaParada(p, cfgParadas), 0);
            const servicoTerminal = this.servicoDeUmaParada(eta.passageiros_terminal, cfgTerminal);
            const deslocamento = Number(eta.deslocamento_sec) || 0;
            const percurso = Number(eta.percurso_sec) || 0;
            const contaTerminal = volta ? this.contabilizaEmbarqueVolta : this.contabilizaDesembarqueIda;
            const totalSec = percurso + servicoParadas
                + (this.incluiDeslocamento ? deslocamento : 0)
                + (contaTerminal ? servicoTerminal : 0);
            return {
                total_min: totalSec / 60,
                percurso_min: percurso / 60,
                deslocamento_min: deslocamento / 60,
                servico_paradas_min: servicoParadas / 60,
                servico_terminal_min: servicoTerminal / 60,
                passageiros_paradas: paradas.reduce((soma, p) => soma + (Number(p) || 0), 0),
                passageiros_terminal: Number(eta.passageiros_terminal) || 0,
                conta_terminal: Boolean(contaTerminal),
            };
        },
        formataMinutosExport(valor) {
            return this.formatMinutos(valor);
        },
        formataDeltaExport(valor) {
            return this.formatDelta(valor);
        },
        /** No PDF não cabe spinner nem chip: status vira o próprio texto da célula. */
        formataEtaExport(valor, item) {
            if (item && item.eta_status && item.eta_status !== 'OK') {
                return this.etaStatusLabel(item.eta_status);
            }
            return this.formatMinutos(valor);
        },
        media(soma, peso) {
            if (!peso) return null;
            return Number((soma / peso).toFixed(2));
        },
        delta(a, b) {
            if (a == null || b == null) return null;
            return Number((a - b).toFixed(2));
        },
        formatMinutos(min) {
            if (min == null || !Number.isFinite(Number(min))) return '—';
            const total = Math.round(Math.abs(Number(min)));
            const hh = String(Math.floor(total / 60)).padStart(2, '0');
            const mm = String(total % 60).padStart(2, '0');
            return `${Number(min) < 0 ? '-' : ''}${hh}:${mm}`;
        },
        formatDelta(min) {
            if (min == null) return '—';
            // Abaixo de meio minuto a célula viraria "-00:00"/"+00:00": sem sinal, e preta.
            const minutos = Math.round(Number(min));
            if (!Number.isFinite(minutos) || minutos === 0) return this.formatMinutos(0);
            return `${minutos > 0 ? '+' : ''}${this.formatMinutos(min)}`;
        },
        /**
         * Cor única para todas as colunas de delta, pelo valor já arredondado ao minuto que a
         * célula mostra: negativo verde, positivo vermelho, 00:00 preto.
         */
        classeDelta(min) {
            if (min == null) return '';
            const minutos = Math.round(Number(min));
            if (!Number.isFinite(minutos) || minutos === 0) return 'black--text';
            return minutos > 0 ? 'error--text' : 'success--text';
        },
        etaStatusLabel(status) {
            const key = ETA_STATUS_KEYS[status] || 'backendError';
            return this.$t(`diagComparacaoEtas.etaStatus.${key}`);
        },
        /** Lista só as parcelas que estão sendo somadas, na ordem em que compõem o ETA. */
        etaComposicao(item) {
            const partes = [
                this.$t('diagComparacaoEtas.messages.etaPartMain', {
                    value: this.formatMinutos(item.eta_percurso_min),
                }),
                this.$t('diagComparacaoEtas.messages.etaPartStops', {
                    value: this.formatMinutos(item.eta_servico_paradas_min),
                }),
            ];
            if (this.incluiDeslocamento) {
                partes.push(this.$t('diagComparacaoEtas.messages.etaPartGarage', {
                    value: this.formatMinutos(item.eta_deslocamento_min),
                }));
            }
            const volta = SENTIDOS_VOLTA.has(Number(item.id_sentido));
            if (volta ? this.contabilizaEmbarqueVolta : this.contabilizaDesembarqueIda) {
                partes.push(this.$t('diagComparacaoEtas.messages.etaPartTerminal', {
                    value: this.formatMinutos(item.eta_servico_terminal_min),
                }));
            }
            return partes.join(' + ');
        },
        amostraFraca(item) {
            return item.media_realizada_min != null
                && Number(item.n_viagens_realizadas) < AMOSTRA_MINIMA_VIAGENS;
        },
        textoCoberturaEta(item) {
            return this.$t('diagComparacaoEtas.messages.etaAverageCoverage', {
                withEta: Number(item.n_horarios_com_eta) || 0,
                total: Number(item.n_horarios) || 0,
            });
        },
        textoQuadrosAgrupados(item) {
            return this.$t('diagComparacaoEtas.messages.mergedTimetables', {
                trips: Number(item.n_viagens_quadro) || 0,
                boards: Number(item.n_quadros) || 0,
            });
        },
        periodoExcedeLimite() {
            if (!this.dti || !this.dtf) return false;
            const inicio = new Date(this.dti).getTime();
            const fim = new Date(this.dtf).getTime();
            if (!Number.isFinite(inicio) || !Number.isFinite(fim)) return false;
            return (fim - inicio) / 86400000 > MAX_DIAS_PERIODO;
        },

        /**
         * Enfileira o relatório no scheduler. O ETA precisa de uma chamada ao VROOM por
         * linha/sentido espaçadas em 1 s, o que leva minutos — longo demais para rodar
         * na requisição da tela.
         */
        async populaRelatorio() {
            if (!this.$refs.form.validate()) return;
            if (!this.dti || !this.dtf) return;
            if (!this.linhasAllMatching && !this.linhasSelecionadas.length) {
                this.aviso = this.$t('diagComparacaoEtas.messages.selectLine');
                return;
            }
            if (this.periodoExcedeLimite()) {
                this.aviso = this.$t('diagComparacaoEtas.messages.rangeTooLong');
                return;
            }

            this.buscando = true;
            this.aviso = "";

            let idLinhas = Array.isArray(this.linhasSelecionadas)
                ? [...this.linhasSelecionadas]
                : [];
            const linhasRef = this.$refs.linhasSelect;
            if (linhasRef && typeof linhasRef.resolveSelection === 'function') {
                try {
                    idLinhas = await linhasRef.resolveSelection();
                } catch (_err) {
                    this.buscando = false;
                    this.aviso = this.$t('diagComparacaoEtas.messages.selectLine');
                    return;
                }
            }
            if (!Array.isArray(idLinhas) || !idLinhas.length) {
                this.buscando = false;
                this.aviso = this.$t('diagComparacaoEtas.messages.selectLine');
                return;
            }
            // Rótulos vêm do cache do select: `resolveSelection` alimenta o cache no modo
            // "Todos" e o watcher de seleção cobre a escolha manual. Sem objeto, o id serve de
            // rótulo — o que não pode é o id sumir da lista consultada.
            this.linhasConsultadas = idLinhas.map((id) => {
                const item = linhasRef && typeof linhasRef.getCachedSelectedItem === 'function'
                    ? linhasRef.getCachedSelectedItem(id)
                    : null;
                return { id_linha: id, nome: this.rotuloLinha(item) || String(id) };
            });
            this.horarios = [];
            this.etaPorLinhaSentido = {};

            apiController.request(apiController.endpoints.solicitacomparacaoetas, {
                data: {
                    id_linhas: idLinhas,
                    dti: DateUtils.getDateSQLFormatted(this.dti),
                    dtf: DateUtils.getDateSQLFormatted(this.dtf),
                },
                onSuccess: (response) => {
                    this.buscando = false;
                    const id = response.data && response.data.id_processo;
                    if (!id) {
                        this.aviso = this.$t('diagComparacaoEtas.messages.enqueueFailed');
                        return;
                    }
                    this.iniciaAcompanhamento(id);
                },
                onError: () => {
                    this.buscando = false;
                    this.aviso = this.$t('diagComparacaoEtas.messages.enqueueFailed');
                },
            });
        },

        iniciaAcompanhamento(idProcesso) {
            this.idProcesso = idProcesso;
            this.statusProcesso = 'PENDING';
            this.etapaAtual = null;
            this.etapaTotal = 0;
            this.etapaConcluidos = 0;
            this.segundosDecorridos = 0;
            try {
                sessionStorage.setItem(STORAGE_KEY, idProcesso);
            } catch (e) {
                // sessionStorage indisponível só custa a retomada ao voltar para a tela.
            }
            this.paraTimers();
            this.elapsedTimer = setInterval(() => { this.segundosDecorridos += 1; }, 1000);
            this.consultaProcesso();
        },

        retomaProcessoPendente() {
            let id = null;
            try {
                id = sessionStorage.getItem(STORAGE_KEY);
            } catch (e) {
                id = null;
            }
            if (!id) return;
            this.iniciaAcompanhamento(id);
        },

        consultaProcesso() {
            if (!this.idProcesso) return;
            apiController.request(apiController.endpoints.schedulerGetProcessoschedulerbyid, {
                data: { id_processo: this.idProcesso },
                silent: true,
                onSuccess: (response) => this.aplicaEstadoProcesso(response.data),
                onError: () => this.encerraAcompanhamento(
                    this.$t('diagComparacaoEtas.messages.trackingFailed')
                ),
            });
        },

        aplicaEstadoProcesso(data) {
            if (!this.idProcesso || !data) return;
            const processo = data.processo || {};
            // Resposta em voo de um processo anterior (cancelado, ou retomado do sessionStorage)
            // pintava o grid com o resultado de outros parâmetros e ainda apagava o id do novo.
            if (processo.id_processo != null
                && String(processo.id_processo) !== String(this.idProcesso)) {
                return;
            }
            this.statusProcesso = processo.status || null;

            const progresso = data.progresso;
            if (progresso && progresso.stage) {
                this.etapaAtual = progresso.stage;
                this.etapaTotal = Number(progresso.total) || 0;
                this.etapaConcluidos = Number(progresso.done) || 0;
            }

            if (this.statusProcesso === 'DONE') {
                this.aplicaResultado(data.resultado);
                return;
            }
            if (this.statusProcesso === 'FAILED' || this.statusProcesso === 'CANCELED') {
                this.encerraAcompanhamento(
                    processo.mensagem_scheduler || this.$t('diagComparacaoEtas.messages.reportFailed')
                );
                return;
            }
            this.pollTimer = setTimeout(() => this.consultaProcesso(), INTERVALO_POLL_MS);
        },

        aplicaResultado(resultado) {
            if (!resultado || resultado.erro) {
                this.encerraAcompanhamento(
                    (resultado && resultado.mensagem) || this.$t('diagComparacaoEtas.messages.reportFailed')
                );
                return;
            }
            // Resultado antigo trazia o ETA já somado (duration + service), sem as parcelas que
            // os filtros ligam e desligam: some com ele em vez de compor número errado.
            if (Number(resultado.versaoEtas) !== VERSAO_ETAS_ESPERADA) {
                this.horarios = [];
                this.etaPorLinhaSentido = {};
                this.encerraAcompanhamento(
                    this.$t('diagComparacaoEtas.messages.staleResult')
                );
                return;
            }
            this.horarios = resultado.horarios || [];
            this.etaPorLinhaSentido = resultado.etas || {};
            const avisos = resultado.avisos || [];
            const mensagens = [];
            if (avisos.includes('boardingsFailed')) {
                mensagens.push(this.$t('diagComparacaoEtas.messages.boardingsFailed'));
            }
            // Grid cheio e nenhuma viagem realizada: sem isto a coluna de média fica só com "—",
            // sem dizer se o período é que não tem viagem concluída.
            if (this.horarios.length
                && !this.horarios.some((r) => Number(r && r.n_viagens_realizadas) > 0)) {
                mensagens.push(this.$t('diagComparacaoEtas.messages.noRealizedTrips'));
            }
            if (this.nomesDasLinhasSemViagens.length) {
                mensagens.push(this.textoLinhasSemViagens(this.nomesDasLinhasSemViagens));
            }
            this.encerraAcompanhamento(mensagens.join(' '));
        },

        encerraAcompanhamento(aviso) {
            this.paraTimers();
            this.idProcesso = null;
            this.statusProcesso = null;
            this.etapaAtual = null;
            try {
                sessionStorage.removeItem(STORAGE_KEY);
            } catch (e) {
                // Nada a fazer: o pior caso é uma retomada órfã, que o próprio poll descarta.
            }
            if (aviso) this.aviso = aviso;
        },

        cancelaProcesso() {
            if (!this.idProcesso) return;
            apiController.request(apiController.endpoints.schedulerCancelaprocesso, {
                data: { id_processo: this.idProcesso },
                silent: true,
                onSuccess: () => this.encerraAcompanhamento(
                    this.$t('diagComparacaoEtas.messages.canceled')
                ),
                onError: () => this.encerraAcompanhamento(
                    this.$t('diagComparacaoEtas.messages.cancelFailed')
                ),
            });
        },

        paraTimers() {
            if (this.pollTimer) {
                clearTimeout(this.pollTimer);
                this.pollTimer = null;
            }
            if (this.elapsedTimer) {
                clearInterval(this.elapsedTimer);
                this.elapsedTimer = null;
            }
        },
    },
};
</script>
<style lang="">

</style>
